/* ================================================================
   marketSwitch.ts — following a link to another market's site.

   The edge in front of the sites geo-redirects visitors to their own
   market unless a `jt_site` cookie (name and domain from region.json
   markets.cookie) says they chose one. So a market link records the
   choice first and only then navigates: a US visitor who picks Australia
   gets jt_site=au and is not bounced back.
   ================================================================ */

import { REGION } from '../config/region';
import { MarketLink, marketCookie, marketUrl } from '../config/market';

/** Every market but this one. */
export const OTHER_MARKETS: MarketLink[] = REGION.markets.list.filter((m) => m.code !== REGION.code);

export function findMarket(code: string): MarketLink | undefined {
  return REGION.markets.list.find((m) => m.code === code);
}

/** The other market's version of the page being viewed (its homepage if it has none). */
export function hrefFor(market: MarketLink, pathname: string): string {
  return marketUrl(market, pathname);
}

/** onClick for a market link: set the cookie, then navigate. */
export function goToMarket(e: { preventDefault(): void }, market: MarketLink, href: string): void {
  e.preventDefault();
  try {
    document.cookie = marketCookie(REGION, market.code);
  } catch {
    // A browser refusing the cookie must not stop the visitor leaving.
  }
  window.location.assign(href);
}
